import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "bootstrap-icons/font/bootstrap-icons.css";

const OurServices = () => {
  const services = [
  {
    id: "home",
    title: "Home Loan",
    icon: "bi-house",
    link: "/home-loan",
    content: [
      "Purchase, construct, or renovate your dream home easily.",
      "Competitive interest rates with flexible tenure options.",
      "High loan eligibility based on income profile.",
      "Minimal documentation and quick approval process.",
      "Transparent charges with easy EMI repayment structure.",
    ],
  },
  {
    id: "personal",
    title: "Personal Loan",
    icon: "bi-person",
    link: "/personal-loan",
    content: [
      "Instant funds for medical, travel, or emergency needs.",
      "Collateral-free loan with simple eligibility criteria.",
      "Quick disbursal and minimal paperwork required.",
      "Flexible repayment tenure options available.",
      "Attractive interest rates with transparent processing.",
    ],
  },
  {
    id: "business",
    title: "Business Loan",
    icon: "bi-briefcase",
    link: "/business-loan",
    content: [
      "Expand your business with reliable funding support.",
      "Manage working capital and operational expenses.",
      "Flexible repayment plans for smooth cash flow.",
      "Quick approval process with structured financing.",
      "Suitable for startups and established businesses.",
    ],
  },
  {
    id: "property",
    title: "Property Loan",
    icon: "bi-building",
    link: "/property-loan",
    content: [
      "Loan against residential or commercial property.",
      "High loan amount based on property valuation.",
      "Competitive interest rates and flexible tenure.",
      "Quick processing and easy documentation.",
      "Ideal for business or personal financial needs.",
    ],
  },
  {
    id: "education",
    title: "Education Loan",
    icon: "bi-mortarboard",
    link: "/education-loan",
    content: [
      "Covers tuition fees and academic expenses.",
      "Support for studies in India and abroad.",
      "Flexible repayment after course completion.",
      "Affordable student-friendly interest rates.",
      "Quick approval with minimal documentation.",
    ],
  },
  {
    id: "car",
    title: "Car Loan",
    icon: "bi-car-front",
    link: "/car-loan",
    content: [
      "Finance new or used cars easily.",
      "Flexible EMI options with competitive rates.",
      "Quick loan sanction and fast disbursal.",
      "Minimal paperwork and simple eligibility.",
      "Affordable tenure plans for easy repayment.",
    ],
  },
  {
    id: "bike",
    title: "Bike Loan",
    icon: "bi-bicycle",
    link: "/bike-loan",
    content: [
      "Own your favorite two-wheeler today.",
      "Low down payment and affordable EMI plans.",
      "Quick approval and fast processing.",
      "Minimal documentation required.",
      "Flexible tenure options available.",
    ],
  },
  {
    id: "marriage",
    title: "Marriage Loan",
    icon: "bi-gift",
    link: "/marriage-loan",
    content: [
      "Cover wedding and celebration expenses easily.",
      "Flexible EMI repayment options.",
      "Quick approval and instant financial support.",
      "Simple eligibility and documentation process.",
      "Make your special day stress-free and memorable.",
    ],
  },
  {
    id: "gold",
    title: "Gold Loan",
    icon: "bi-award",
    link: "/gold-loan",
    content: [
      "Instant funds against gold ornaments.",
      "Safe and secure gold storage facility.",
      "Same-day approval and disbursal.",
      "Competitive interest rates available.",
      "Flexible repayment options to suit your needs.",
    ],
  },
  {
    id: "credit",
    title: "Loan on Credit Card",
    icon: "bi-credit-card-2-front",
    link: "/credit-card-loan",
    content: [
      "Convert credit limit into instant cash.",
      "No additional documentation required.",
      "Flexible EMI repayment structure.",
      "Quick approval and instant disbursal.",
      "Convenient solution for short-term needs.",
    ],
  },
];


  const [activeIndex, setActiveIndex] = useState(0);
  const rowRef = useRef(null);

  // 🔹 Auto Slide
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === services.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [services.length]);

  // 🔹 Scroll Active Tab Into View
//   useEffect(() => {
//     const activeButton = rowRef.current?.children[activeIndex];
//     activeButton?.scrollIntoView({
//       behavior: "smooth",
//     //   inline: "center",
//       block: "nearest",
//     });
//   }, [activeIndex]);

  const activeService = services[activeIndex];

  return (
    <section className="py-5 bg-light">
      <div className="container text-center px-4">
        <h2 className="mb-5 fw-bold">Our Services</h2>

        {/* Tabs Row */}
        <div className="services-row mb-4" ref={rowRef}>
          {services.map((service, index) => (
            <button
              key={service.id}
              className={`service-tab ${
                activeIndex === index ? "active-tab" : ""
              }`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="icon-wrapper">
                <i className={`bi ${service.icon}`}></i>
              </div>
              <p className="mt-3 mb-0">{service.title}</p>
              {activeIndex === index && <div className="arrow-down"></div>}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="service-content shadow-sm p-4 bg-white rounded">
          <p>{activeService.content}</p>

          {/* 🔹 Read More Button (New Line) */}
          <Link
            to={activeService.link}
            className="btn btn-primary mt-3"
          >
            Read More
          </Link>
        </div>
      </div>

      {/* Styling */}
      <style>{`
        .services-row {
          display: flex;
          flex-wrap: nowrap;
          gap: 20px;
          overflow-x: auto;
          padding-bottom: 20px;
          scroll-behavior: smooth;
        }

        .services-row::-webkit-scrollbar {
          display: none;
        }

        .service-tab {
          flex: 0 0 auto;
          background: #f8f9fa;
          border: 1px solid #e0e0e0;
          padding: 25px 30px;
          border-radius: 10px;
          cursor: pointer;
          transition: 0.3s;
          position: relative;
          min-width: 170px;
        }

        .active-tab {
          background: #ffffff;
          box-shadow: 0 6px 20px rgba(0,0,0,0.12);
          border: 2px solid #1fa5a9;
        }

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: #e9ecef;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-size: 24px;
          color: #1fa5a9;
        }

        .arrow-down {
          width: 20px;
          height: 20px;
          background: white;
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          box-shadow: 3px 3px 8px rgba(0,0,0,0.08);
        }

        .service-content {
          max-width: 900px;
          margin: auto;
          font-size: 16px;
          line-height: 1.7;
        }
      `}</style>
    </section>
  );
};

export default OurServices;
